import ApiFiles from 'services/api_files';
import Api from '../api';

interface updateDocumentParams {
  id: number;
  description: string;
  document_type_id: number;
  expiration_date: any;
}

interface Download {
  isRepresentant: boolean;
  is_aws: boolean;
  fileUrl: string;
  name: string;
  cnpj: number | null;
  companyId: number | null;
  id: number;
}

interface DocumentRef {
  id: number | string;
  source: 'db' | 's3';
  cnpj: number | null;
  companyId: number | null;
  isRepresentant: boolean;
}

export const getPendingDocumentsCount = async (companyId: number) => {
  const response = await Api.get(`/documentos/count_documents`, { params: { companyId } });
  return response?.data?.total_documentos;
};

export const getDocumentsGroups = async () => {
  const response = await Api.get(`/document_groups.json`);

  return response?.data?.document_groups;
};

export const getDocumentTypesList = async (documentGroupId: number) => {
  const response = await Api.get(`document_types.json`, { params: { documentGroupId } });
  const data = response?.data?.document_types;
  return typeof data === 'string' ? JSON.parse(data) : data;
};

export const postUpdateDocument = async (document: updateDocumentParams, cnpj: string) => {
  const response = await Api.post(`/documento/${document.id}`, { document, cnpj });

  return response;
};

const filenameFromContentDisposition = (contentDisposition?: string): string | null => {
  if (!contentDisposition) return null;

  const encoded = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (encoded) return decodeURIComponent(encoded[1]);

  const plain = contentDisposition.match(/filename="([^"]+)"/i);
  return plain ? plain[1] : null;
};

export const downLoadFiles = async (
  documents_list: Array<Download>,
  setLoading?: (loading: boolean) => void,
) => {
  try {
    setLoading?.(true);
    const refs: DocumentRef[] = documents_list.map((doc) => ({
      id: doc.id,
      source: doc.is_aws ? 's3' : 'db',
      cnpj: doc.cnpj,
      companyId: doc.companyId,
      isRepresentant: doc.isRepresentant,
    }));

    const response = await ApiFiles.get('/documentos/download', {
      params: { document_refs: refs },
      responseType: 'blob',
    });

    const filename =
      filenameFromContentDisposition(response.headers?.['content-disposition']) ||
      `documentos_${Date.now()}.zip`;

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } finally {
    setLoading?.(false);
  }
};

export const sendEmail = async (
  documents_list: Array<Download>,
  email: string,
  selectedCompany: string,
) => {
  const refs: DocumentRef[] = documents_list.map((doc) => ({
    id: doc.id,
    source: doc.is_aws ? 's3' : 'db',
    cnpj: doc.cnpj,
    companyId: doc.companyId,
    isRepresentant: doc.isRepresentant,
  }));
  const response = await Api.get('/documentos/send_to_email', {
    params: {
      email,
      selectedCompany,
      documents_list: refs,
    },
  });

  return response;
};
